.list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  padding: 28px 24px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-bg-card);
}

.number {
  display: block;
  margin-bottom: 16px;
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  color: var(--color-purple-bright);
  opacity: 0.85;
}

.text {
  font-size: 15px;
  line-height: 1.6;
  color: var(--color-text-muted);
}

@media (max-width: 768px) {
  .list {
    grid-template-columns: 1fr;
  }
}
